import { render, staticRenderFns } from "./icibe.vue?vue&type=template&id=330ddfba&scoped=true"
import script from "./icibe.vue?vue&type=script&lang=js"
export * from "./icibe.vue?vue&type=script&lang=js"
import style0 from "./icibe.vue?vue&type=style&index=0&id=330ddfba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330ddfba",
  null
  
)

export default component.exports